"use client";
import { useEffect, useRef } from "react";
import Dropdown from "../dropdown/Dropdown";
import styles from "./index.module.css";

const sortOptions = [
  { value: "relevance", label: "Relevance" },
  { value: "desc", label: "Price - High To Low" },
  { value: "asc", label: "Price - Low To High" },
];

const MarketplaceSort = ({ searchTerm, sortOrder, setSortOrder, isMobile }) => {
  const prevSearchRef = useRef("");

  useEffect(() => {
    const prev = prevSearchRef.current;

    // reset sort whenever a new search is started
    if (searchTerm !== prev) {
      setSortOrder("relevance");
    }

    prevSearchRef.current = searchTerm;
  }, [searchTerm]);

  // MOBILE DROPDOWN
  if (isMobile) {
    return (
      <Dropdown
        options={sortOptions}
        value={sortOrder}
        onSelect={(opt) => setSortOrder(opt.value)}
        getOptionValue={(opt) => opt.value}
        getOptionLabel={(opt) => opt.label}
        className={styles.mobileSortDropdown}
      />
    );
  }

  // DESKTOP BUTTONS
  return (
    <div className={styles.sortContainer}>
      Sort By:
      <div className={styles.sortContainerBtns}>
        <div
          role="button"
          className={`${styles.sortBtn} ${
            sortOrder === "relevance" ? styles.activeSort : ""
          }`}
          onClick={() => setSortOrder("relevance")}
        >
          Relevance
        </div>

        <div
          role="button"
          className={`${styles.sortBtn} ${
            sortOrder === "desc" ? styles.activeSort : ""
          }`}
          onClick={() => setSortOrder("desc")}
        >
          Price - High To Low
        </div>

        <div
          role="button"
          className={`${styles.sortBtn} ${
            sortOrder === "asc" ? styles.activeSort : ""
          }`}
          onClick={() => setSortOrder("asc")}
        >
          Price - Low To High
        </div>
      </div>
    </div>
  );
};

export default MarketplaceSort;
